import type { AreaSubstrate } from 'paintscout'

export default function convertPrep(areaSubstrate: AreaSubstrate): number {
  let prep = 0
  if (typeof areaSubstrate.prep === 'string') {
    prep = Number.parseFloat(areaSubstrate.prep)
  } else {
    prep = Number(areaSubstrate.prep)
  }
  if (Number.isNaN(prep)) {
    prep = 0
  }

  return prep
}
